/*
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  SPDX-License-Identifier: MIT-0 
*/

export default {
  setUsername(state: { cognitoUserName: string }, payload: string): void {
    state.cognitoUserName = payload;
  },
  setEmail(state: { email: string }, payload: string): void {
    state.email = payload;
  },
  setGivenName(state: { givenName: string }, payload: string): void {
    state.givenName = payload;
  },
  setFamilyName(state: { familyName: string }, payload: string): void {
    state.familyName = payload;
  },
  setStationCode(state: { stationCode: string }, payload: string): void {
    state.stationCode = payload;
  },
  setCompanyName(state: { companyName: string }, payload: string): void {
    state.companyName = payload;
  },
  setTitle(state: { title: string }, payload: string): void {
    state.title = payload;
  },
  setDepartment(state: { department: string }, payload: string): void {
    state.department = payload;
  },
};
